import { CompanyWithInvoiceCode } from '../../containers/Admin/Property/types'
import { Organization } from '../Company'

export enum PaymentSchedule {
    MONTHLY = 'MONTHLY',
    ANNUALLY = 'ANNUALLY',
}

export interface QuickbooksCustomer {
    id: number
    quickbooks_id: number
    display_name: string
    fully_qualified_name: string
    print_on_check_name: string
    company_name: string
    email_address: string
    billing_address: number | null
    quickbooks_created_at: string
}

export interface BillingGroup {
    id: number
    quickbooks_customer: QuickbooksCustomer
    invoice_email: string
    payment_schedule: PaymentSchedule
    active: boolean
    organization: Organization
    companies: CompanyWithInvoiceCode[]
    last_invoice_date: string | null
}
